import { createAction, props } from "@ngrx/store";

import { Guest, User } from "@hermes/api-model-account";

// Guest Actions
export const fetchGuest = createAction("[User] Fetch guest data");

export const fetchGuestSuccess = createAction(
    "[User] Fetch guest data success",
    props<{ guest: Guest }>(),
);

export const removeGuest = createAction("[User] Remove guest data");
export const removeGuestSuccess = createAction(
    "[User] Remove guest data success",
);

export const updateGuest = createAction(
    "[User] Update guest data",
    props<{ guest: Guest }>(),
);

// User Actions
export const setUser = createAction(
    "[User] Set a new user ",
    props<{ user: User }>(),
);

export const clearUserData = createAction("[User] Clear user data");
export const clearUserDataSuccess = createAction(
    "[User] Clear user data success",
);
